import { render, staticRenderFns } from "./IndagineEpidemiologicaEdit.vue?vue&type=template&id=8d9c8322"
import script from "./IndagineEpidemiologicaEdit.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports